// The last store picked in the top bar, kept per browser (its key is a build setting). "All stores" is kept beside it
// under the same key + ":all" (the brand's hash), so leaving "All stores" goes back to the store picked before.
const STORE_KEY = import.meta.env.VUE_APP_LOCAL_STORAGE_PATH;
const ALL_KEY = STORE_KEY ? STORE_KEY + ":all" : "";

export const ALL_STORES_LABEL = "All stores";

const getStoresDefaultState = () => {
  return {
    status: false,
    stores: "",
    ut: "", // TODO: What is the meaning?
    current: {
      brandHash: "",
      brandName: "",
      storeHash: "",
      storeName: "",
      lat: null,
      lng: null,
      // "All stores": the brand's totals. storeHash is then "" so that nothing which needs one store can run
      // with a store that is no longer picked; the brand stays set.
      allStores: false,
    },
    vSelectedTab: 0,
    // The last "All stores" report a page added up: { page, stores, missing: [names], failed: [names] }, shown
    // under that page's header (ReportHeader) so a total that leaves a store out says so.
    coverage: null,
  };
};

const fromStore = (item) => ({
  brandHash: item.bhash,
  brandName: item.b_name,
  storeHash: item.shash,
  storeName: item.s_name,
  lat: item.location_lat,
  lng: item.location_lng,
  allStores: false,
});

function remember(storeHash, allBrandHash) {
  try {
    if (storeHash && STORE_KEY) localStorage.setItem(STORE_KEY, storeHash);
    if (!ALL_KEY) return;
    if (allBrandHash) localStorage.setItem(ALL_KEY, allBrandHash);
    else localStorage.removeItem(ALL_KEY);
  } catch (e) {
    // Storage can be off (private window); the choice then lasts until the page is reloaded.
  }
}

/** What this browser last had in the top bar: { storeHash, allBrandHash }, either may be "". */
export function rememberedChoice() {
  try {
    return {
      storeHash: (STORE_KEY && localStorage.getItem(STORE_KEY)) || "",
      allBrandHash: (ALL_KEY && localStorage.getItem(ALL_KEY)) || "",
    };
  } catch (e) {
    return { storeHash: "", allBrandHash: "" };
  }
}

const stores = {
  state: getStoresDefaultState(),
  mutations: {
    SET_STORE_LIST(state, payload) {
      Object.assign(state, payload);
    },
    SET_CURRENT_STORE(state, payload) {
      Object.assign(state.current, payload);
    },
    SET_ALL_STORES_COVERAGE(state, payload) {
      state.coverage = payload;
    },
  },
  actions: {
    setStoreDetails({ state, commit }, storeHash) {
      const item = state.stores.find((s) => s.shash === storeHash);
      if (!item) return;
      commit("SET_CURRENT_STORE", fromStore(item));
      remember(storeHash, "");
    },
    /** Look at every store of a brand at once (the brand of the current store when none is named). */
    setAllStores({ state, commit }, brandHash) {
      const list = Array.isArray(state.stores) ? state.stores : [];
      const bhash = brandHash || state.current.brandHash || (list[0] && list[0].bhash);
      const first = list.find((s) => s.bhash === bhash);
      if (!first) return;
      commit("SET_CURRENT_STORE", {
        brandHash: bhash,
        brandName: first.b_name,
        storeHash: "",
        storeName: ALL_STORES_LABEL,
        lat: null,
        lng: null,
        allStores: true,
      });
      remember("", bhash);
    },
  },
  getters: {
    getFirstStoreHash: (state) => {
      return state.stores[0].shash;
    },
    isAllStores: (state) => !!state.current.allStores,
    /** The stores "All stores" adds up: every store of the current brand in the person's list. */
    brandStores: (state) =>
      (Array.isArray(state.stores) ? state.stores : []).filter((s) => s.bhash === state.current.brandHash),
  },
};

export default stores;
